angular.module("app").controller("EditSkinPageController", [
    '$scope',
    'preloadedSkinData',
    'preloadedLanguages',
    'deepCompare',
    'generalService',
    'skinService',
    'logger',
    'errorHandler',
    '$timeout',
    '$uibModalInstance',
    'preloadedLicense',
    'releaseServers',
    'preloadedProducts',
    function ($scope, preloadedSkinData, preloadedLanguages, deepCompare, generalService, skinService, logger, errorHandler, $timeout, $modalInstance, preloadedLicense, releaseServers, preloadedProducts) {
        var sourceData = angular.copy(preloadedSkinData.skin);
        $scope.showAuthenticationFieldsRequired = {
            show: false
        };
        $scope.skin = angular.copy(sourceData);
        $scope.skin.server = $scope.skin.server_name || releaseServers.webDefault;
        $scope.skin.mobile_server = $scope.skin.mobile_server_name || releaseServers.mobileDefault;
        $scope.skin.new_mobile_server = $scope.skin.new_mobile_server_name || releaseServers.mobileDefault;
        $scope.skin.new_web_server = $scope.skin.new_web_server_name || releaseServers.webDefault;
        $scope.skin.loyalty_program_version = sourceData.loyalty_program_version === 2;
        $scope.skin.game_auto_approve = +!sourceData.game_auto_approve;
        $scope.skin.allow_casino_ai_order = sourceData.allow_casino_ai_order === 1;
        $scope.skin.is_live = sourceData.is_live === 1;

        $scope.products = preloadedProducts;
        $scope.tooltip = {
            id: "",
            basehost: "",
            url: "",
            name:""
        };

        var languageTitleNameMap = {};
        var languageNameTitleMap = {};
        var licenseNameIdMap = {};
        var licenseIdNameMap = {};
        $scope.licenses = preloadedLicense;

        $scope.languageTitles = preloadedLanguages.languages.map(function (item) {
            var title = item.title + " (" + item.name.toUpperCase() +")";
            languageTitleNameMap[title] = item.name;
            languageNameTitleMap[item.name] = title;
            return title;
        });

        $scope.languages = {
            selected: function () {
                var formattedLanguages = [];
                sourceData.languages.forEach(function (value) {
                    formattedLanguages.push(languageNameTitleMap[value])
                });
                return formattedLanguages
            }()
        };

        $scope.skin.defaultLang = languageNameTitleMap[$scope.skin.defaultLang];

        $scope.ownContentLanguages = {
            selected: function () {
                var formattedLanguages = [];
                sourceData.ownContentLanguages.forEach(function (value) {
                    formattedLanguages.push(languageNameTitleMap[value])
                });
                return formattedLanguages
            }()
        };
        $scope.releaseServers = releaseServers.web;
        $scope.mobileReleaseServers = releaseServers.mobile;


        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return function () {
                $timeout(function () {
                    $scope.ownContentLanguages.all = angular.copy(getSelectedLanguages());

                    if ($scope.ownContentLanguages.all.length == 0) {
                        $scope.ownContentLanguages.selected = [];
                    }

                    var ownContentLanguages = [],
                        selectedArr = angular.copy($scope.ownContentLanguages.selected);

                    $scope.ownContentLanguages.all.forEach(function (languageObj) {
                        ownContentLanguages.push(languageObj.name)
                    });

                    for (var i = 0, length = $scope.ownContentLanguages.selected.length; i < length; i++) {
                        if (ownContentLanguages.indexOf($scope.ownContentLanguages.selected[i].id) == -1) {
                            selectedArr.splice(i, 1)
                        }
                    }
                    $scope.ownContentLanguages.selected = selectedArr;

                })
            }()
        };

        function getSelectedLanguages () {
            var arr = [],
                languages = [],
                i = 0,
                length = preloadedLanguages.languages.length;

            $scope.languages.selected.forEach(function (languageObj) {
                languages.push(languageObj.id)
            });

            for (i, length; i < length; i++) {
                if (languages.indexOf(preloadedLanguages.languages[i]["name"]) != -1) {
                    arr.push(angular.copy(preloadedLanguages.languages[i]))
                }
            }
            return arr
        }

        $scope.save = function () {
            if (!$scope.edit_skin_form.$valid) {
                $scope.isSavePressed = true;
                $scope.showAuthenticationFieldsRequired.show = !!($scope.skin.authLogin || $scope.skin.authPass);
                return;
            } else if (!$scope.allowUpdate()) {
                logger.logError("global.no_changes");
                return;
            }
            var requestData = {},
                fetchedData = fetchRequestData(),
                changes = deepCompare.getChanges(angular.copy(sourceData), fetchedData.skin) || deepCompare.getChanges(fetchedData.skin, angular.copy(sourceData));

            changes.languages && (changes.languages = fetchedData.skin.languages);
            changes.ownContentLanguages && (changes.ownContentLanguages = fetchedData.skin.ownContentLanguages);
            if (!angular.equals(sourceData.products,  fetchedData.skin.products)) {
                changes.products = fetchedData.skin.products;
            }

            if (changes.authLogin && !changes.authPass) {
                changes.authPass = fetchedData.skin.authPass;
            } else if (!changes.authLogin && changes.authPass) {
                changes.authLogin = fetchedData.skin.authLogin;
            }

            changes.is_live = $scope.skin.is_live ? $scope.skin.is_live : 0;
            changes.game_auto_approve = +!$scope.skin.game_auto_approve;
            changes.allow_casino_ai_order = $scope.skin.allow_casino_ai_order ? $scope.skin.allow_casino_ai_order : 0;
            changes.loyalty_program_version = changes.loyalty_program_version?2:1;

            requestData.skin = changes;
            requestData.skin.id = $scope.skin.id;
            generalService.editSkin(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("Skin has been successfully updated");
                        $scope.skin = angular.copy(fetchedData.skin);
                        sourceData = angular.copy(fetchedData.skin);
                        $scope.edit_skin_form && $scope.edit_skin_form.$setPristine && $scope.edit_skin_form.$setPristine();
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.allowUpdate = function () {
            var changes = deepCompare.getChanges(angular.copy(sourceData), fetchRequestData().skin) || deepCompare.getChanges(fetchRequestData().skin, angular.copy(sourceData));
            return !!changes
        };

        $scope.generate = function () {
            skinService.generate({skin_id: $scope.skin.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("generated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function fetchRequestData() {
            var requestData = {
                skin: angular.copy($scope.skin)
            };

            requestData.skin.languages = [];
            requestData.skin.ownContentLanguages = [];


            $scope.languages.selected.forEach(function (languageObj) {
                requestData.skin.languages.push(languageTitleNameMap[languageObj])
            });

            $scope.ownContentLanguages.selected.forEach(function (languageObj) {
                requestData.skin.ownContentLanguages.push(languageTitleNameMap[languageObj]);
            });


            requestData.skin.defaultLang && (requestData.skin.defaultLang = languageTitleNameMap[requestData.skin.defaultLang] );

            return requestData
        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        /**
         * Build Mobile
         */
        $scope.buildMobile = function buildMobile(){
            skinService.buildMobile({skin_id: $scope.skin.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("Mobile site successfully built");
                        $scope.skin.mobile_build_status = "PENDING";
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

    }
]);
